import React from 'react';
// import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.scss';
// import App from "./App";
import Education from "./components/education/education";
import Compare from './components/compare/compare';
import CityEmbed from "./components/city/city";
import qs from "qs";

const queryClient = new QueryClient();

function getEl(embedSelector) {
    if (typeof embedSelector === "string") {
        const el = document.querySelector(embedSelector);
        // if (!el) throw new Error(`No div matching selector "${embedSelector}"`);
        if (!el) return;
        return el;
    } else {
        return embedSelector;
    }
}

function getEls(embedSelector) {
    if (typeof embedSelector === "string") {
        const els = document.querySelectorAll(embedSelector);
        // if (!els) throw new Error(`No divs matching selector "${embedSelector}"`);
        if (!els) return;
        return els;
    } else {
        return embedSelector;
    }
}

function getUrlParams() {
    const params = qs.parse(window.location.search.slice(1));

    return {
        type: params.embed,
        city: params.city,
    };
}

// window.addEventListener("DOMContentLoaded", () => {
//     const params = getUrlParams();
    
//     if (params) {

//     //     if (getEl("[data-education-2024]")) {
//     //         const container = getEl("[data-education-2024]");
//     //         const root = createRoot(container); // createRoot(container!) if you use TypeScript
//     //         // ReactDOM.render(<App {...params} />, getEl("[data-app-embed]"));
//     //         root.render(<App {...params} />);
//     //     }
//       [...getEls("[data-country-embed]")].map((e) => {
//         // ReactDOM.render(<CityEmbed {...params} citySlug={e.getAttribute("data-country-embed")}/>, e);
//         ReactDOM.render(<CityEmbed {...params} citySlug={e.getAttribute("data-country-embed")}/>, e);
//       })

//       if (getEl("[data-education-2024]")) {
//         ReactDOM.render(<App {...params} />, getEl("[data-education-2024]"));
//       }
//     }
// });

window.addEventListener("DOMContentLoaded", () => {
  const params = getUrlParams();
  
  if (params) {
      if (getEl("[data-opportunityIndex-2025]")) {
        const container = getEl("[data-opportunityIndex-2025]");
        const root = createRoot(container); // createRoot(container!) if you use TypeScript
        // ReactDOM.render(<App {...params} />, getEl("[data-app-embed]"));
        root.render(
            <QueryClientProvider client={queryClient}>
                <Education {...params} />
            </QueryClientProvider>
        );
      }

      if (getEl("[data-opportunityIndex-compare-2025]")) {
          const container = getEl("[data-opportunityIndex-compare-2025]");
          const root = createRoot(container); // createRoot(container!) if you use TypeScript
          // ReactDOM.render(<App {...params} />, getEl("[data-app-embed]"));
          root.render(
              <QueryClientProvider client={queryClient}>
                <Compare {...params} />
              </QueryClientProvider>
          );
      }
      
      
      [...getEls("[data-country-embed]")].forEach((container) => {
          const root = createRoot(container); // createRoot(container!) if you use TypeScript
          root.render(
              <QueryClientProvider client={queryClient}>
                <CityEmbed {...params} citySlug={container.getAttribute("data-country-embed")}/>
              </QueryClientProvider>
          );
      })
      
  }
});
